export const DEFAULT_APP_VERSION = '1.0.0';

const SEMVER_PATTERN = /^v?\d+\.\d+\.\d+(?:[-+][0-9A-Za-z.-]+)?$/;

export const isSemverVersion = (version) => {
  return SEMVER_PATTERN.test(String(version || '').trim());
};

export const normalizeClientVersion = (
  version,
  fallbackVersion = DEFAULT_APP_VERSION,
) => {
  const candidate = String(version || '').trim();

  if (isSemverVersion(candidate)) {
    return candidate.replace(/^v/, '');
  }

  const fallback = String(fallbackVersion || DEFAULT_APP_VERSION).trim();
  return isSemverVersion(fallback) ? fallback.replace(/^v/, '') : DEFAULT_APP_VERSION;
};
